export default function (state, data) {
    state.events.today = [];
    state.events.tomorrow = [];
    let date = parsing_date(data.CurrentDate.Serialized);
    data.EventStatistic.forEach(item => {
        item.key = '' + item.EventTypeId + item.EV_ID;
        item.date = parsing_date(item.EventTime.Serialized.split(' ')[0]);
        if (item.date.getTime() === date.getTime()) state.events.today.push(item);
        else state.events.tomorrow.push(item);
    });
}

function parsing_date(val, option) {
    if (!val) return false;
    let mask = (option && option.mask) ? option.mask : 'DD.MM.YYYY';
    return new Date(getNum(val, mask, 'YYYY'), getNum(val, mask, 'MM') - 1, getNum(val, mask, 'DD'))
}

function getNum(val, mask, type) {
    let a = mask.indexOf(type);
    let b = '';
    for (let i = 0; i < type.length; i++) {
        b += val[a + i];
    }
    return b * 1;
}